import React from 'react'
import PropTypes from 'prop-types'
import InnerHTML from 'dangerously-set-html-content'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Flexlink from '../components/Flexlink'



const MealContent = ({ title, subtitle, content, image, aLaCartePrice, description, largePrice, largePriceDescription, mealType, menus, regularPrice, regularPriceDescription, smallPrice, smallPriceDescription }) => {
    const t = title
    const goBack = () => { 
        window.history.back()
    }
    const data = useStaticQuery(graphql`
            query Sides {
                allWpMeal {
                    edges {
                        node {
                            uri
                            slug
                            title
                            mealOptions {
                                subtitle
                                menus {
                                    ... on WpZMenu {
                                        title 
                                    }
                                }
                            }
                            featuredImage {
                                node {
                                    localFile {
                                        url
                                        publicURL
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `)

  return (
    <div className='panel'>

        <div className="yoast-breadcrumbs">
            <span>
                <span>
                    <Link to="/">Home</Link> / 
                    <span><Link to="/menus">Menus</Link> / 
                        <span>
                            <Link to="/take-home-menu">Take Home Menu</Link>
                        </span>
                    </span>
                </span>
            </span>
        </div>
        
            <img 
                src={image?.node?.mediaItemUrl}
                onError = {e => e.target.style.display = 'none'}
                srcSet={image?.node?.srcSet}
                alt="menu"
                width={1200} 
                height={600}
                className="main-image"
            />
            
        <h1 className='meal-title'>{t}</h1>
        <h4>{subtitle}</h4>

        <p>{description}</p><br />

        

        {regularPrice ? <p className='meal-price regular'><span>{regularPrice} {regularPriceDescription ? <dd>{regularPriceDescription}</dd> : ''}</span></p> : ''}

        {aLaCartePrice ? <p className='meal-price'><span>A la carte</span><span></span><span>{aLaCartePrice}</span></p> : ''}

        {largePrice ? <p className='meal-price'><span>Large</span><span></span><span>{largePrice} {largePriceDescription ? <dd>{largePriceDescription}</dd> : ''}</span></p> : ''}

        {smallPrice ?  <p className='meal-price'><span>Small</span><span></span><span>{smallPrice} {smallPriceDescription ? <dd>{smallPriceDescription}</dd> : ''}</span></p> : ''}

        {content ? <InnerHTML html={content} /> : ''}
      
        {

            mealType === '1' || mealType === '3' ?
            <React.Fragment>

                <h2>Homemade Side Choices</h2>
                <div className='grid2'>
                    {data.allWpMeal.edges?.map(({ node, index }) => (
    
                        node.mealOptions.menus?.map(({ title }) => (
                                                    
                            title === 'Homemade Sides' ?
                        
                            <article key={'side-'+index}>
                                <Flexlink to={node.uri}>
                                    
                                    <img 
                                    src={node?.featuredImage?.node?.localFile?.url} 
                                    onError = {e => e.target.style.display = 'none'}
                                    alt="meal"
                                    width={400} 
                                    height={400}
                                    className="grid-image2"
                                    />
                                     
                                </Flexlink>
                                <h6>
                                    <Flexlink to={node.uri}>{node.title}</Flexlink>
                                </h6>
                            </article>
                        
                            : ''
                        ))
                    ))}
                </div>

            </React.Fragment>
            : ''

                        
        }
      
      <button onClick={() => {goBack()}} className="close" aria-label="close"></button>
    </div>
  )
}

MealContent.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

export default MealContent;